import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useAppSelector } from './reduxHooks'
import type { ShareConfig } from 'components/Common/Modals/ShareModal/ShareModal'
import { addQueryParamsToUrl } from 'lib/url/searchUrlUtils'
import config from 'constants/config'
import useShareVariant from './useShareVariant'
import { getFirstName } from 'selectors/accountSelectors'

interface UseCheckoutShareConfigOptions {
  includeSharedBy?: boolean
}

function useCheckoutShareConfig(options: UseCheckoutShareConfigOptions = {}): ShareConfig {
  const { includeSharedBy = false } = options
  const customerPortalURL = useAppSelector((state) => state.system.customerPortalURL)
  const pathname = useAppSelector((state) => state.router.location.pathname)
  const shareVariant = useShareVariant()
  const firstName = useAppSelector(getFirstName)
  const intl = useIntl()

  return useMemo(() => {
    const removedRegionPathname = pathname.replace(/^\/[a-z]+/, '')
    const url = addQueryParamsToUrl(`${customerPortalURL}${removedRegionPathname}`, {
      utm_campaign: 'checkoutshare',
      utm_source: config.BRAND,
      utm_medium: 'web',
      share_variant: shareVariant,
      ...(includeSharedBy && firstName ? { shared_by: firstName } : undefined),
    })

    const message = intl.formatMessage({
      id: '4lEuXARqXXTqD_hn_zIQ',
      defaultMessage: 'Check out this amazing cruise!',
      description: 'Share message used when sharing a cruise checkout page link',
    })

    return {
      url,
      shareTitle: message,
      shareMessage: message,
      pageId: removedRegionPathname,
      pageType: 'offer',
      shareVariant,
    }
  }, [customerPortalURL, pathname, shareVariant, includeSharedBy, firstName, intl])
}

export default useCheckoutShareConfig
